module.exports = __webpack_public_path__ + "img/rivka.9e9b0f3d.png";